module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex center-xs top-xs feed-component h-100 re-center-roundtable-feed-component"
  }, [_c('div', [(_vm.hasTeacherPermissionsInCourse) ? _c('roundtable-settings-in-feed', {
    key: 'roundtable-settings-in-feed'
  }) : _vm._e(), _vm._v(" "), _c('prompt-in-feed', {
    key: 'prompt-in-feed',
    staticStyle: {
      "overflow-wrap": "break-word"
    },
    on: {
      "toggleEditPrompt": function($event) {
        _vm.edit_prompt = !_vm.edit_prompt
      }
    }
  }), _vm._v(" "), (_vm.no_submissions) ? _c('div', {
    staticClass: "no-responses-message"
  }, [_vm._v("\n        Student responses will populate here. There are none yet.\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.edit_prompt) ? _c('div', {
    staticClass: "transparent-modal"
  }, [_c('prompt-in-feed-modal', {
    key: 'prompt-in-feed',
    staticStyle: {
      "overflow-wrap": "break-word"
    },
    attrs: {
      "editPrompt": _vm.edit_prompt
    },
    on: {
      "toggleEditPrompt": function($event) {
        _vm.edit_prompt = !_vm.edit_prompt
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.show_delete_submission_modal) ? _c('dialog-delete-confirm', {
    attrs: {
      "optionalText": "Submission"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_submission_modal = false
      },
      "actionConfirmed": _vm.deleteSubmission
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.show_hide_submission_modal) ? _c('pl-confirm', {
    staticClass: "tl",
    attrs: {
      "typeConfirm": false,
      "confirmText": "Hide"
    },
    on: {
      "confirm": _vm.confirmHideSubmission,
      "close": function($event) {
        _vm.show_hide_submission_modal = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "pl-title bold"
  }, [_vm._v("Hide Submission")]), _vm._v(" "), _c('p', [_vm._v("\n          This will hide the submission and associated comments from\n          participants in the RoundTable. Only you and the original poster can\n          see it from now on.\n        ")]), _vm._v(" "), _c('p', [_vm._v("You can undo this at any time.")])])]) : _vm._e(), _vm._v(" "), (_vm.show_delete_comment_dialog) ? _c('pl-dialog', {
    attrs: {
      "maxWidth": '500px',
      "header": "Are you sure you want to DELETE this comment?"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_comment_dialog = false
      }
    }
  }, [_c('pl-input', {
    attrs: {
      "labelText": _vm.label_confirm_msg,
      "errorMessage": _vm.error_message_computed
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.closeDialog('confirm-delete-comment', 'delete-comment')
      }
    },
    model: {
      value: (_vm.confirm),
      callback: function($$v) {
        _vm.confirm = $$v
      },
      expression: "confirm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row end-xs"
  }, [_c('pl-button', {
    staticClass: "pl-primary-font",
    nativeOn: {
      "click": function($event) {
        return _vm.cancelDelete()
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary-font",
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('confirm-delete-comment', 'delete-comment')
      }
    }
  }, [_vm._v("OK")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.show_hide_comment_modal) ? _c('pl-confirm', {
    staticClass: "tl",
    attrs: {
      "typeConfirm": false,
      "confirmText": "HIDE"
    },
    on: {
      "confirm": _vm.hideComment,
      "close": function($event) {
        _vm.show_hide_comment_modal = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "pl-title bold"
  }, [_vm._v("Hide Comment")]), _vm._v(" "), _c('p', [_vm._v("\n          This will hide the comment and associated replies from participants\n          in the RoundTable. Only you and the original poster can see it from\n          now on.\n        ")]), _vm._v(" "), _c('p', [_vm._v("You can undo this at any time.")])])]) : _vm._e(), _vm._v(" "), (_vm.show_flag_dialog) ? _c('pl-dialog', {
    attrs: {
      "header": "Are you sure you would like to flag this?"
    },
    on: {
      "close": function($event) {
        _vm.show_flag_dialog = false
      }
    }
  }, [_c('div', {
    staticClass: "row end-xs"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        _vm.show_flag_dialog = false
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('confirm-flag', 'flag')
      }
    }
  }, [_vm._v("OK")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.show_assessment_modal) ? _c('pl-dialog', {
    attrs: {
      "maxHeight": "80%",
      "width": "80%",
      "max-width": "700px"
    },
    on: {
      "close": function($event) {
        _vm.show_assessment_modal = false
      }
    }
  }, [(Number(_vm.getCurrentRT.point_cap) > 0) ? _c('div', {
    staticClass: "pl-subheading start-xs",
    staticStyle: {
      "padding": "10px 30px"
    }
  }, [_vm._v("\n        Max Score: " + _vm._s(Number(_vm.getCurrentRT.point_cap)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row no-margin start-xs scroll",
    staticStyle: {
      "padding": "10px 20px"
    }
  }, _vm._l((_vm.getCurrentRT.points_settings.peer_rewards), function(point) {
    return _c('div', {
      key: point.tag,
      staticClass: "col-xs-6 start-xs",
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('span', {
      staticClass: "pl-title"
    }, [_vm._v("\n            " + _vm._s(point.title) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "pl-body-2 row no-margin start-xs middle-xs"
    }, [_c('p', [_vm._v("\n              " + _vm._s(typeof point.description === 'object' ?
      point.description.join('. ') :
      point.description) + "\n            ")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.show_confirm_delete_feedback) ? _c('dialog-delete-confirm', {
    attrs: {
      "header": 'Delete this saved feedback template',
      "subHeader": 'It will be permanently removed from this course.'
    },
    on: {
      "close": function($event) {
        _vm.show_confirm_delete_feedback = false
      },
      "actionConfirmed": _vm.confirmDeleteSavedFeedback
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_saved_feedback_modal) ? _c('saved-feedback-modal', {
    attrs: {
      "feedbackID": _vm.feedback_id,
      "feedbackContent": _vm.feedback_content,
      "focusOnMounted": true,
      "isEditFeedback": _vm.set_edit_saved_feedback,
      "rtType": 'online'
    },
    on: {
      "modalFeedbackClosed": _vm.closeSavedFeedbackModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_import_feedback_modal) ? _c('import-saved-feedback-modal', {
    attrs: {
      "onlineRT": true
    },
    on: {
      "modalFeedbackClosed": function($event) {
        _vm.show_import_feedback_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_point_creation_modal) ? _c('create-new-point-modal', {
    attrs: {
      "activityType": _vm.activityType,
      "tag": _vm.selected_point_tag,
      "rts": _vm.roundtables_with_point
    },
    on: {
      "close": function($event) {
        _vm.show_point_creation_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_anonymous_description_modal) ? _c('anonymous-character-description-modal', {
    attrs: {
      "anonymous_identity": _vm.identity_to_show
    },
    on: {
      "close": function($event) {
        _vm.show_anonymous_description_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_delete_point_modal) ? _c('dialog-delete-confirm', {
    attrs: {
      "optionalText": "Are you sure you want to delete this Point?"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_point_modal = false
      },
      "actionConfirmed": _vm.deleteAssessmentPoint
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_alert_assessment_changing) ? [_c('pl-dialog', {
    staticClass: "center-xs",
    attrs: {
      "maxWidth": '600px',
      "padding": '2em'
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    }
  }, [_c('pl-button', {
    staticStyle: {
      "min-width": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeAssessmentChangingAlert.apply(null, arguments)
      }
    }
  }, [_c('strong', {
    staticClass: "f4"
  }, [_vm._v("X")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "header pv3"
  }, [_c('span', {
    staticClass: "pl-secondary b",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n            Heads up!\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "ph3",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('p', [_vm._v("\n            Changing (or deleting) this assessment criteria for this\n            RoundTable will change (or delete) it for all of the other\n            RoundTables in this course that also use this criteria:\n          ")]), _vm._v(" "), _c('ul', _vm._l((_vm.displayCriteriaRts), function(roundtable) {
    return _c('li', {
      key: roundtable.id,
      staticClass: "b"
    }, [_vm._v("\n              " + _vm._s(roundtable.title) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pv2"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    staticStyle: {
      "font-size": "16px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeAssessmentChangingAlert.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Okay, Got it.\n          ")])], 1)])] : _vm._e(), _vm._v(" "), (_vm.show_unsubmitted_modal) ? _c('pl-dialog', {
    attrs: {
      "height": "80%",
      "maxWidth": "630px"
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "position": "absolute",
      "top": "12px",
      "right": "12px",
      "margin": "0"
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_unsubmitted_modal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-lg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "avatar-circle avatar-size ml3"
  }, [_c('img', {
    attrs: {
      "src": _vm.unsubmitted_response.user.avatar_url,
      "alt": "avatar"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tl ml3"
  }, [_c('p', {
    staticClass: "ma0 pl-title"
  }, [_vm._v(_vm._s(_vm.unsubmitted_response.user.name))]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "ma0 ruby-text i"
  }, [_vm._v("Unsubmitted")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "unsubmitted-text-section"
  }, [_c('section', {
    staticClass: "prompt-response ph3 tl",
    staticStyle: {
      "font-weight": "500"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.unsubmitted_response.draft_response)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "i pl3 tl mt4",
    staticStyle: {
      "font-size": "12px",
      "color": "#273248"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.unsubmitted_response.word_count) + " Words\n        ")])])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4a15459f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/pages/feed/feed.vue
// module id = 1376
// module chunks = 61